import { colors } from '@/utils';

const strokeActionSoft50 = colors.stroke.action.soft['50'];
const strokeActionSolid100 = colors.stroke.action.solid['100'];
const penHeaderInteractive = colors.text.action['200'];

/** Shared transition for camera selector styled components. */
export const cameraSelectorTransition = 'all 120ms ease' as const;

/**
 * Color tokens for the camera selector pen groups and camera cards.
 *
 * @example cameraSelectorColors.penHeader.hover
 * @example cameraSelectorColors.selectCard.background.selected
 */
export const cameraSelectorColors = {
  penHeader: {
    default: colors.text.neutral.contrast,
    hover: penHeaderInteractive,
    focus: penHeaderInteractive,
    selected: colors.text.action['100'],
  },
  cardGrid: {
    border: {
      default: colors.background.transparent['0'],
      hover: strokeActionSoft50,
      focus: strokeActionSolid100,
      selected: strokeActionSoft50,
    },
    background: {
      hover: colors.background.action.solid['100'],
      focus: colors.background.action.soft['300'],
      selected: colors.background.action.soft['100'],
    },
  },
  selectCard: {
    border: {
      default: colors.stroke.neutral[50],
      selected: strokeActionSolid100,
      hover: {
        default: colors.stroke.action.soft['100'],
        selected: colors.stroke.action.solid['200'],
      },
      focus: strokeActionSolid100,
    },
    background: {
      default: colors.surface.default,
      selected: colors.background.action.solid['100'],
      hover: {
        default: colors.background.action.soft['50'],
        selected: colors.background.action.solid['200'],
      },
    },
    color: {
      default: colors.text.neutral.contrast,
      selected: colors.text.action.on.solid['100'],
    },
    focusRing: strokeActionSolid100,
  },
} as const;
